import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["href"]

import { type PropType, ref } from "vue";
import popup from "../header/appearance-containers/modal/modal.vue";
import CoolButton from "../shared/CoolButton.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'basic-popup',
  props: {
    message: {
        type: String,
        required: true,
    },
    links: {
        type: Array as PropType<{ link: string; text: string }[]>,
        required: true,
    },
},
  setup(__props) {


const open = ref(true);
function close() {
    //this.$el.remove();
    //this.$destroy();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(popup, {
      modelValue: open.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event)),
      "content-class": _ctx.$style['popup-content'],
      onClose: close
    }, {
      "close-button": _withCtx(({ close: cl }) => [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['close-button']),
          onClick: ($event: any) => (cl())
        }, "×", 10 /* CLASS, PROPS */, _hoisted_1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['inner-popup-content'])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style['inner-popup-upper-text'])
          }, _toDisplayString(__props.message), 3 /* TEXT, CLASS */),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style['buttons'])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.$style['button-item'])
              }, [
                _createVNode(CoolButton, { size: "large" }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: link.link,
                      class: _normalizeClass(_ctx.$style['button'])
                    }, _toDisplayString(link.text), 11 /* TEXT, CLASS, PROPS */, _hoisted_2)
                  ], undefined, true),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */)
              ], 2 /* CLASS */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 2 /* CLASS */)
        ], 2 /* CLASS */)
      ], undefined, true),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "content-class"])
  ]))
}
}

})